var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 3.125C45.8301 3.125 46.875 4.1748 46.875 5.46875C46.875 6.7627 45.8301 7.8125 44.5312 7.8125H8.59375C6.43652 7.8125 4.6875 9.56152 4.6875 11.7188V38.2812C4.6875 40.4395 6.43652 42.1875 8.59375 42.1875H41.4062C43.5645 42.1875 45.3125 40.4395 45.3125 38.2812V21.0938C45.3125 18.9355 43.5645 17.1875 41.4062 17.1875H11.7188C10.4199 17.1875 9.375 16.1426 9.375 14.8438C9.375 13.5449 10.4199 12.5 11.7188 12.5H41.4062C46.1523 12.5 50 16.3477 50 21.0938V38.2812C50 43.0273 46.1523 46.875 41.4062 46.875H8.59375C3.84766 46.875 0 43.0273 0 38.2812V11.7188C0 6.97266 3.84766 3.125 8.59375 3.125H44.5312ZM34.375 29.6875C34.375 27.959 35.7715 26.5625 37.5 26.5625C39.2285 26.5625 40.625 27.959 40.625 29.6875C40.625 31.416 39.2285 32.8125 37.5 32.8125C35.7715 32.8125 34.375 31.416 34.375 29.6875Z",
    fill: "url(#paint0_linear_235_1197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_1197",
    x1: -3.36134,
    y1: -15.25,
    x2: 45.5389,
    y2: -6.90289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9075E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d646ff2af39a48cb0f85ec62dddf6c2d.svg";
export { ForwardRef as ReactComponent };